import React from 'react';
import { winMarkets } from '../../../enums/statisticTypes';

export function WinMarketsCountMobile({ statistics }) {
  if (!statistics) {
    return null;
  }

  return (
    <div className='betting-block-top'>
      {winMarkets.map(({ id, className, iconClass, text, hashtag, name }) => (
        <div className='sheet-t-items' key={id}>
          {className && (
            <div className={className}>
              <span className={iconClass}>{text || ''}</span>
            </div>
          )}
          <span className='chips-number'>
            {hashtag || ''}
            {statistics[name]}
          </span>
        </div>
      ))}
    </div>
  );
}
